module.exports = __webpack_public_path__ + "static/media/u24b_7.0a5be1e8.mp3";